'use client';

import { useEffect, useRef } from 'react';
import { useUser } from '@ui/shared/UserProvider/UserProvider';
import useTrackAnalyticsEventApplicationOpened from '@lib/analytics/useTrackAnalyticsEventApplicationOpened';

export default function ApplicationOpenedByAuthenticatedUserTracker() {
  const user = useUserOrNull();
  const isReportedRef = useRef(false);
  const track = useTrackAnalyticsEventApplicationOpened();

  useEffect(() => {
    if (user === null || isReportedRef.current) {
      return;
    }

    track({
      type: 'APPLICATION_OPENED_BY_AUTHENTICATED_USER',
      metadata: {},
    });
    isReportedRef.current = true;
  }, [user, track]);

  return null;
}

function useUserOrNull() {
  try {
    return useUser();
  } catch {
    return null;
  }
}
